import React from 'react';
import { users } from 'types';
import {
    Box,
    BoxTitle,
    BoxContent,
} from 'components/layout/box/custom-box.styled';
import mapEkycStatus from 'data-mappers/map-ekyc-status';
import { Divider } from '@material-ui/core';
import timeFormat from 'utils/time-format';
import {
    EEkycStatuesesApi,
    IEKYCDetails,
} from '../../../../../types/entities/users';

export type TUserAccountInfoProps = {
    user: users.TUsersDetail;
    ekycDetails: IEKYCDetails | undefined;
};

const UserAccountInfo: React.FC<TUserAccountInfoProps> = ({
    user,
    ekycDetails,
}) => {
    const getRiskProfileScoreMapping = (riskScore: number) => {
        if (riskScore <= 1) {
            return 'High Risk';
        } else if (riskScore > 2) {
            return 'Low Risk';
        } else {
            return 'Medium Risk';
        }
    };

    const fullName = () => {
        if (ekycDetails && ekycDetails.name) {
            return `${ekycDetails.name}`;
        }
        if (user.firstName === user.lastName) {
            return `${user.firstName}`;
        }
        if (user.lastName === null) {
            return `${user.firstName}`;
        }
        return `${user.firstName} ${user.lastName}`;
    };

    const usedName = fullName();

    return (
        <Box>
            <BoxTitle>User Account</BoxTitle>
            <BoxContent>
                <div>
                    <span>User ID</span>
                    <span>{user?.id || '-'}</span>
                </div>
                <Divider />
                <div>
                    <span>Nex ID</span>
                    <span>@{user?.nexId || '-'}</span>
                </div>
                <Divider />
                <div>
                    <span>Status</span>
                    <span>{user?.status || '-'}</span>
                </div>
                <Divider />
                <div>
                    <span>EKYC Status</span>
                    <span>
                        {mapEkycStatus(user?.ekyc.status)}
                    </span>
                </div>
                <Divider />
                <div>
                    <span>Account Number</span>
                    <span>{user?.wallet.accountNo || '-'}</span>
                </div>
                <Divider />
                <div>
                    <span>Full Name</span>
                    <span>{usedName}</span>
                </div>
                <Divider />
                <div>
                    <span>Login Blocked At</span>
                    <span>{user?.loginBlockedAt ? timeFormat(user.loginBlockedAt, false) : '-'}</span>
                </div>
                <Divider />
                <div>
                    <span>Created At</span>
                    <span>{timeFormat(user?.createdAt, false) || '-'}</span>
                </div>
                {user.ekyc.status === 3 && (
                    <>
                        <Divider />
                        <div>
                            <span>Rejection Note</span>
                            <span>{user?.ekyc.rejectionNote || '-'}</span>
                        </div>
                    </>
                )}
                {user.riskProfile && (
                    <>
                        <Divider />
                        <div>
                            <span>Risk Profile Score</span>
                            <span>
                                {user.ekyc.status ===
                                EEkycStatuesesApi.EKYC_STATUS_UNVERIFIED
                                    ? '-'
                                    : `${getRiskProfileScoreMapping(
                                          user.riskProfile.riskScore,
                                      )} (Score: ${user.riskProfile.riskScore})`}
                            </span>
                        </div>
                    </>
                )}
            </BoxContent>
        </Box>
    );
};

export default UserAccountInfo;
